import { toast } from 'react-toastify';

const error = (message, opts = {}) =>
  toast(message, { type: 'error', ...opts });

const success = (message) => toast(message, { type: 'success' });

const info = (message) => toast(message, { type: 'info' });

const warn = (message, opts = {}) =>
  toast(message, { type: 'warning', ...opts });

export default {
  error,
  success,
  info,
  warn,
};
